import React from 'react'
import "../landing.css"
import "../landingResponsive.css"
import {shoes} from "./shoes.js"
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'  

function Scroller() {

  const slideLeft = () => {
    var slider = document.getElementById('slider');
    slider.scrollLeft = slider.scrollLeft - 750;
  }

  const slideRight = () => {
      var slider = document.getElementById('slider');
      slider.scrollLeft  = slider.scrollLeft + 750;
  }

  const [isImageHovered, setImageHovered] = useState(false)
  const [clickedImageIndex, setClickedImageIndex] = useState(null);

  const openPopup = (index) => {
    setClickedImageIndex(index);
  };

  const closePopup = () => {
    setClickedImageIndex(null);
  };

  return (
    <div className='scroller'>
      <i onClick={slideLeft} className="fa-solid fa-chevron-left"/>
      <div id='slider' className='scroller-slider'>        
      {
        shoes.map((item, index) => {
            return(
              <Link>
                <div className='products' onMouseEnter={() => setImageHovered(index)} onMouseLeave={() => setImageHovered(false)}>
                    <img className={isImageHovered === index ? 'img-product hovered' : 'img-product'} src={item.img} onClick={() => openPopup(index)} />
                    <h2 className={isImageHovered === index ? 'title-product hovered' : 'title-product'}>{item.title}</h2>
                    {clickedImageIndex === index && (
                      <div  className='overlay'>
                        <div className='popup-shoes'>
                          <i class="fa-solid fa-x" onClick={closePopup}></i>
                          <img className='popup-shoes-img' src={item.img}/>
                        </div>
                      </div>
                    )}
                </div>
              </Link>
            )
        })
        }
        </div>

      <i onClick={slideRight} className="fa-solid fa-chevron-right"/>
    </div>
  )
}

export default Scroller